/**
 * Shared look for people shown as initials in a tinted circle (customers on
 * the Save Order sheet and the sale customer bar, staff chips).
 */
export const PERSON_AVATAR_COLORS = [
  '#DBEAFE', // light blue
  '#E2E8F0', // light grey
  '#DBEAFE', // light blue
  '#E8DEF8', // light lavender
  '#FFDDD2', // light peach
  '#D1FAE5', // light mint
  '#FEF3C7', // light yellow
  '#FCE7F3', // light pink
] as const;

export const PERSON_AVATAR_INITIALS_COLOR = '#1E3A5F';

/** Small cloud badge marking a customer that exists in the back office. */
export const LINKED_BADGE_COLORS = {
  background: '#EBF2FA',
  icon: '#5B93D3',
} as const;

export const getPersonAvatarColorByIndex = (index: number): string =>
  PERSON_AVATAR_COLORS[Math.abs(index) % PERSON_AVATAR_COLORS.length];

/**
 * Colour is derived from the name rather than a row index so a person keeps
 * the same tint while a list is being filtered.
 */
export const getPersonAvatarColor = (name: string): string => {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = (hash + name.charCodeAt(i)) % PERSON_AVATAR_COLORS.length;
  }
  return PERSON_AVATAR_COLORS[hash];
};

/** "Musembi Kamau" → "MK"; a single word gives its first two letters. */
export const getPersonInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};
